import React from 'react';
// import './HowItsWorks.css';


const steps = [
  {
    icon: '📝',
    title: 'Sign Up',
    description: 'Start with our free trial. No credit card required.',
  },
  {
    icon: '📄',
    title: 'Create Requests',
    description: 'Customize your document requests with ease.',
  },
  {
    icon: '🔗',
    title: 'Invite Clients',
    description: 'Clients receive an invite to upload documents securely.',
  },
  {
    icon: '✅',
    title: 'Review & Manage',
    description: 'Approve or reject submissions, and organize completed documents.',
  },
];

  const HowItsWorks = () => {
  return (
    <section className="howitworks-section bg-dark-subtle">
      <div className="container">
        <div className="howitworks-header">
          {/* <img src={logo} alt="DocuSafe.ai Logo" className="howitworks-logo" /> */}
          <h2 className="howitworks-title">How <span>DocuSafe.ai</span> Works</h2>
        </div>
        <div className="howitworks-steps">
          {steps.map((step, idx) => (
            <div className="howitworks-step" key={idx}>
              <div className="howitworks-circle">
                <span className="howitworks-icon">{step.icon}</span>
              </div>
              <div className="howitworks-stepnum">0{idx + 1}</div>
              <div className="howitworks-steptitle">{step.title}</div>
              <div className="howitworks-stepdesc">{step.description}</div>
              {idx < steps.length - 1 && (
                <div className="howitworks-connector">
                  <svg width="80" height="32" viewBox="0 0 80 32" fill="none">
                    <path d="M0 16 Q40 32 80 16" stroke="#FF9900" strokeWidth="3" fill="none" strokeDasharray="6,6" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItsWorks;